import "./ToursVisitsLecturesPage.css";
import VISITORS from "../assets/images/education/visits-lectures.avif";
import PLANTING from "../assets/images/education/planting-small.avif";
import { FormEvent } from "react";
import Hero from "../components/Hero";
import { useCompanyDetails } from "../hooks/useCompanyDetails";
import { buildMailtoLink } from "../utils/companyContact";

const ToursVisitsLecturesPage = () => {
  const { data: companyDetails } = useCompanyDetails();
  const contactEmail = companyDetails?.companyEmailAddress?.trim();
  const contactMailto = buildMailtoLink(contactEmail);

  function handleSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    //TODO the form is not sent anywhere
  }
  return (
    <>
      <Hero page="tours-visits-lectures" titleTwo="Tours, Visits & Lectures" />
      <div className="visits-page-container content-container">
        {" "}
        <div className="visits-page-column">
          <img
            src={VISITORS}
            alt="empty benches and a farmer waiting for students in a green house"
          />
          <h2>Plan your educational visit with us!</h2>
          <p>
            A part of our education concept at the farm is to share and
            co-create knowledge about agroecology with different groups. Farm
            tours & lectures are a great way to make our knowledge and
            experiences accessible to a wider public.{" "}
          </p>
          <ul>
            <span className="bold">Practical information:</span>
            <li className="visits-practical-li">
              Our general working language at the farm is English, tours in
              Swedish are possible only upon request.
            </li>
            <li className="visits-practical-li">
              Farm tours and practical experiences are available from February
              to November according to our team capacities. Please note that
              during May, we usually have a lower capacity.{" "}
            </li>
            <li className="visits-practical-li">
              Accessibility: The garden and our social area are physically
              accessible to a large degree. If your group has specific needs for
              accessibility, please let us know in advance. We will try to
              accommodate for your needs within our capacities.{" "}
            </li>{" "}
          </ul>
          <p className="tours-link-to-contact-email">
            Please contact us for any other specific questions you might have.{" "}
            {contactMailto ? (
              <a href={contactMailto}>{contactEmail}</a>
            ) : (
              contactEmail
            )}
          </p>{" "}
          <p className="tours-visits-lectures-form-notice">
            Fill in the form with the information of your visit and we will get
            back to you via email.{" "}
          </p>{" "}
          <img src={PLANTING} alt="hands planting a seed" />
        </div>
        {/*--- FORM ---- */}
        <div className="visits-application-column">
          <h2>Send your request here: </h2>
          <form onSubmit={handleSubmit} className="visit-application-form">
            <div className="visit-form-input-with-label">
              <label htmlFor="first-name">First Name</label>
              <input type="text" name="firstName" id="first-name" required />
            </div>
            <div className="visit-form-input-with-label">
              <label htmlFor="last-name">Last Name</label>
              <input type="text" name="lastName" id="last-name" required />
            </div>
            <div className="visit-form-input-with-label">
              <label htmlFor="email">Email</label>
              <input type="email" name="email" id="email" required />
            </div>
            <div className="visit-form-input-with-label">
              <label htmlFor="institution">Institution/Organization</label>
              <input type="text" name="institution" id="institution" />
            </div>
            <fieldset>
              <legend>
                Select the type of educational service you are requesting:
              </legend>
              <div className="visit-form-input-with-label">
                <label>
                  <input type="radio" name="service" value="tour" />
                  Farm Tour
                </label>
              </div>
              <div className="visit-form-input-with-label">
                <label>
                  <input type="radio" name="service" value="lecture" />
                  Lecture
                </label>
              </div>
              <div className="visit-form-input-with-label">
                <label>
                  <input type="radio" name="service" value="workshop" />
                  Workshop
                </label>
              </div>
              <div className="visit-form-input-with-label">
                <label>
                  <input type="radio" name="service" value="other" />
                  Other
                </label>
              </div>
            </fieldset>
            <div className="visit-form-input-with-label">
              <label htmlFor="topic">
                Please describe the purpose of the activity (e.g., specific
                topic, learning objectives, or type of experience desired).
              </label>
              <input type="text" name="topic" id="topic" required />
            </div>
            <div className="visit-form-input-with-label">
              <label htmlFor="date">Date</label>
              <input type="date" name="daate" id="date" required />
            </div>{" "}
            <div className="visit-form-input-with-label">
              <label htmlFor="time">Time</label>{" "}
              <input type="time" name="time" id="time" required />
            </div>
            <div className="visit-form-input-with-label">
              <label htmlFor="group-size">Group Size</label>
              <select id="group-size" name="groupSize">
                <option value="1-15">1-15</option>
                <option value="16-30">16-30</option>
                <option value="31-50">31-50</option>
                <option value="51-80">51-80</option>
                <option value="81+">81+</option>
              </select>
            </div>
            <div className="visit-form-input-with-label">
              <label htmlFor="length-of-visit">Length of visit</label>
              <select id="length-of-visit" name="lengthOfVisit">
                <option value="1hour">1 hour</option>
                <option value="2hours">2 hours</option>
                <option value="3hours">3 hours</option>
                <option value="3+hour">More than 3 hours</option>
              </select>
            </div>
            <label className="visit-form-checkbox-label">
              <input
                type="checkbox"
                name="terms"
                required
                className="visit-form-checkbox"
              />
              Our educational services have a fee, which helps us continue the
              work we do. We understand that some non-profit organizations have
              limited budgets, and we’re happy to discuss options to make our
              programs accessible while still supporting our work. Please note
              that we are unable to provide services completely free of charge.
            </label>{" "}
            <div className="visit-form-input-with-label">
              <label htmlFor="budget">
                If your organization is a non-profit or has a limited budget,
                please let us know and share your approximate budget for this
                activity:
              </label>{" "}
              <textarea name="budget" id="budget" required />
            </div>
            <button className="btn visit-submition-btn" type="button">
              Submit
            </button>
          </form>
        </div>
      </div>
    </>
  );
};

export default ToursVisitsLecturesPage;
